module.exports = function t(input, path, interpolations) {
  const { i18n } = require("@pathwright/ui/src/components/lng/I18nextProvider")
  return i18n.t(path, interpolations)
}
